import React from 'react';
import { ReactComponent as OperationModel } from '../../assets/ic_operation_model.svg';

const OperationModelIcon = () => <OperationModel />;

export default OperationModelIcon;
